import { SectionWrapper } from '../components/SectionWrapper';
import { StudyCard } from '../components/StudyCard';

import styles from './StudyAtAGlanceSection.module.css';

const cards = [
  {
    body: 'Undergraduate course at a major research university. AI hints embedded directly in homework via Kudu.',
    eyebrow: 'Setting',
    title: 'Intro Physics',
  },
  {
    body: 'Specifically, do they help most the students least likely to ask a TA, peer, or instructor for support?',
    eyebrow: 'Question',
    title: 'Do these interventions actually help?',
  },
  {
    body: 'Scaled extra credit on supplemental math, plus AI-generated hints in physics homework. Both optional, both available to every student equally.',
    eyebrow: 'Design',
    title: 'Two interventions, controlled',
  },
  {
    body: 'Higher exam performance for students using the interventions. Fewer completion gaps among students historically underserved in STEM.',
    eyebrow: 'Results',
    title: 'Both worked. The effects are concrete.',
  },
];

export function StudyAtAGlanceSection() {
  return (
    <SectionWrapper background="soft" data-testid="research-section-glance">
      <div className={styles.section}>
        <div className={styles.header}>
          <p className={styles.eyebrow}>THE AIMS STUDY AT A GLANCE</p>
          <h2 className={styles.title}>One study. One question. Real classrooms.</h2>
          <p className={styles.body}>
            Researchers at UCLA&apos;s Center for Education Innovation and
            Learning in the Sciences (CEILS), partnered with UC San Diego, set
            out to test whether two specific interventions - scaled extra
            credit and AI-generated hints - could close the gap between
            students who arrive in introductory physics with strong math
            preparation and those who don&apos;t.
          </p>
        </div>
        <div className={styles.cards}>
          {cards.map((card) => (
            <StudyCard key={card.eyebrow} {...card} />
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
}
